import React from 'react';
import PropTypes from 'prop-types';
import Title from '../Title/Title';
import styles from './SectionContainer.module.scss';

SectionContainer.propTypes = {
    sectionTitle: PropTypes.string,
    childre: PropTypes.array
};

function SectionContainer(props) {
    const classesTitle = `${styles.titleWrapper} ${props.classNameTitle}`;
    const classesContent = `${styles.content} ${props.classNameContent}`;

    return (
        <div className={styles.sectionContainer}>        
            <div className={styles.titleWrapper}>
                <Title level="3">{props.sectionTitle}</Title>
            </div>                      
            <div className={classesContent}>
                {props.children}
            </div>            
        </div>
    );
}

export default SectionContainer;